/**
 * Type guards for safe type narrowing from unknown
 */

export const isError = (error: unknown): error is Error => {
    return error instanceof Error;
};

export const hasMessage = (error: unknown): error is { message: string } => {
    return typeof error === 'object' && error !== null && 'message' in error;
};

export const hasResponse = (error: unknown): error is { response: { status: number; data?: unknown } } => {
    if (typeof error !== 'object' || error === null || !('response' in error)) {
        return false;
    }
    const errorObj = error as Record<string, unknown>;
    const response = errorObj.response;
    return typeof response === 'object' && response !== null && 'status' in response;
};

export const isAxiosError = (
    error: unknown
): error is {
    response: { status: number; data?: unknown };
    message: string;
    name: string;
} => {
    return hasResponse(error) && hasMessage(error) && 'name' in error;
};

export const getErrorMessage = (error: unknown): string => {
    if (isError(error)) {
        return error.message;
    }
    if (hasMessage(error)) {
        return error.message;
    }
    if (typeof error === 'string') {
        return error;
    }
    return 'Unknown error occurred';
};

export const hasProperty = <T extends string>(obj: unknown, prop: T): obj is Record<T, unknown> => {
    return typeof obj === 'object' && obj !== null && prop in obj;
};
